import { render, staticRenderFns } from "./FieldTag.vue?vue&type=template&id=bf9eef56&scoped=true"
import script from "./FieldTag.vue?vue&type=script&lang=js"
export * from "./FieldTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9eef56",
  null
  
)

export default component.exports